import { createContext } from "react";
import { SubscriptionStatus } from "../lib/types";

const SubscriptionStatusContext = createContext<SubscriptionStatus | null>(null);

export default SubscriptionStatusContext
